var _rect, _path, _path2, _circle, _path3, _path4, _path5, _path6, _path7;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMyLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 174,
    height: 94,
    viewBox: "0 0 174 94",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 2.01953,
    width: 170.153,
    height: 89.5888,
    stroke: "white",
    strokeWidth: 3
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.4713 34.9223C28.643 34.9223 27.9168 34.7691 27.2927 34.4627C26.6686 34.145 26.1807 33.7082 25.829 33.1522C25.4886 32.5848 25.3184 31.9267 25.3184 31.1778V25.9015C25.3184 25.1413 25.4886 24.4832 25.829 23.9272C26.1807 23.3712 26.6686 22.94 27.2927 22.6336C27.9168 22.3159 28.643 22.157 29.4713 22.157C30.311 22.157 31.0372 22.3159 31.6499 22.6336C32.274 22.94 32.7562 23.3712 33.0966 23.9272C33.4484 24.4832 33.6243 25.1413 33.6243 25.9015H31.0712C31.0712 25.4022 30.9294 25.0221 30.6457 24.7612C30.3734 24.5002 29.9819 24.3697 29.4713 24.3697C28.9607 24.3697 28.5636 24.5002 28.2799 24.7612C28.0076 25.0221 27.8714 25.4022 27.8714 25.9015V31.1778C27.8714 31.6657 28.0076 32.0458 28.2799 32.3182C28.5636 32.5791 28.9607 32.7096 29.4713 32.7096C29.9819 32.7096 30.3734 32.5791 30.6457 32.3182C30.9294 32.0458 31.0712 31.6657 31.0712 31.1778H33.6243C33.6243 31.9267 33.4484 32.5848 33.0966 33.1522C32.7562 33.7082 32.274 34.145 31.6499 34.4627C31.0372 34.7691 30.311 34.9223 29.4713 34.9223Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.48 46.7521V51.7521H26.3999V71.4321H32.3999V51.7521H38.3198V46.7521H32.3999H26.3999H20.48Z",
    fill: "white"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 65.7996,
    cy: 28.3694,
    r: 6.38262,
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.8799 51.7521V46.7521H62.7998H68.7998H74.7197V51.7521H68.7998V66.4302H74.7197V71.4302H68.7998V71.4321H62.7998V71.4302H56.8799V66.4302H62.7998V51.7521H56.8799Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M98.1692 34.754V22.3291H102.203C103.065 22.3291 103.814 22.4937 104.45 22.8227C105.096 23.1518 105.596 23.617 105.948 24.2184C106.311 24.8084 106.492 25.5063 106.492 26.3119V30.7542C106.492 31.5485 106.311 32.2463 105.948 32.8477C105.596 33.4491 105.096 33.92 104.45 34.2604C103.814 34.5894 103.065 34.754 102.203 34.754H98.1692ZM100.722 32.3711H102.203C102.725 32.3711 103.145 32.2236 103.463 31.9286C103.78 31.6336 103.939 31.2421 103.939 30.7542V26.3119C103.939 25.8353 103.78 25.4495 103.463 25.1545C103.145 24.8595 102.725 24.712 102.203 24.712H100.722V32.3711Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M97.4038 46.754H92.4038V71.4321H97.4038V57.7747L99.2434 62.9924L99.4009 63.4454H105.01L105.412 62.2642L106.995 57.7747V71.4321H111.995V46.754H106.995L102.199 60.3561L97.4038 46.754Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M134.859 34.749V22.3241H142.518V24.5027H137.361V27.2941H141.922V29.4727H137.361V32.5704H142.518V34.749H134.859Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M136.559 46.749H135.53L125.796 68.3308L125.726 68.3774L125.763 68.4055L124.4 71.427H129.732L129.737 71.4161L129.758 71.4321L143.39 62.2131L147.46 71.427H152.792L147.41 59.4943L152.801 55.8488L148.343 53.4639L145.528 55.3204L141.662 46.749H140.633H136.559ZM141.514 57.9668L138.596 51.3602L133.279 63.3969L141.514 57.9668Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyLogo);
export default __webpack_public_path__ + "static/media/myLogo.876ff763fd3df44751ef84a8b6f29193.svg";
export { ForwardRef as ReactComponent };